import { render, staticRenderFns } from "./BuyerRtbSettings.vue?vue&type=template&id=1254bd10&lang=true"
import script from "./BuyerRtbSettings.vue?vue&type=script&lang=js"
export * from "./BuyerRtbSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports